/**
 * Translation injection for apps using the Bikemap UI components.
 */

export { default as TranslationProvider } from './TranslationProvider.jsx'
export { default as translated } from './translated.jsx'
